/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from "react";
import {
    makeStyles,
    createStyles,
    Grid,
    Typography,
    Select,
    MenuItem,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Paper,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { ConfirmReservationCard } from "./components/ConfirmReservationCard";
import { useParams } from "react-router";
import { IAnnounce } from "../../utils/AnnounceInterfaces";
import {
    announceDefaultValue,
    paymentDefaultValue,
} from "../../utils/defaultNullValues";
import { AnnouncesService } from "../Announces/services/AnnounceService";
import {
    getDayNumber,
    useQuery,
    paymentMethodList,
    getProviderIdentifier,
    getDayNumberProm,
    totalPayecredit,
} from "../../utils/App";
import { ReservationContext, UserContext } from "../../contexts/AppContext";
import MultiSelectWithCheckBox from "../components/MultiSelectWithCheckBox";
import { ConfirmationReservationService } from "./services/ConfirmationReservationService";
import { IUserService } from "../../Services/userServecesServices";
import { SelectedServiceItem } from "./components/SelectedServiceItem";
import { IBookingPayment } from "../../utils/PaymentInterfaces";
import { useHistory, useLocation } from "react-router-dom";
import SessionHandler from "../../https/SessionHandler";
import { PaypalBookingPaymentButtons } from "../components/Payments/PaypalBookingPaymentButtons";
import PropagateLoader from "react-spinners/PropagateLoader";
import {
    EPaymentMethod,
    ETransactionType,
} from "../../utils/enum/PaymentMethod";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import { DohonePayementButton } from "../components/Payments/DohonePayementButton";
import { FlashMessage } from "../components/FlashMessage";
import { ConvertedDeviseWithoutMoneySign } from "../../utils/CurrencyConvertFunction";
import { EStatus, ETarifs } from "../../utils/enum";
import Spin from "../../images/Spin";
import { GuestCheckoutForm } from "../components/GuestCheckoutForm";
import { LoginForm } from "../components/Login/LoginForm";
import MasterCard_logo from "../../images/MasterCard_logo.jpg";
import MTNMobileMoney_logo from "../../images/MTNMobileMoney_logo.jpg";
import OrangeMoney_logo from "../../images/OrangeMoney_logo.jpg";
import PayPal_logo from "../../images/PayPal_logo.jpg";
import Visa2_logo from "../../images/Visa2_logo.jpg";


const useStyles = makeStyles((theme) => (
    createStyles({
        submit: {
            width: "50%",
            backgroundColor: "#890608",
            borderRadius: 100,
            "&:hover": {
                background: "#EA7606",
            },
            "&.MuiButton-root": {
                color: "white",
            },
        },
        bolder: {
            fontWeight: "bolder",
        },
        title: {
            color: "#4D4F5C",
            fontSize: 18,
            fontWeight: 500,
            fontFamily:
                'Josefin Sans,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
        },
        reservationTitle: {
            fontSize: 22,
            fontFamily: "Josefin Sans",
            color: "#890608",
            marginTop: 40,
            textAlign: "center",
        },
        contentDialog: {
            borderTop: "1px solid rgba(0, 0, 0, 0.12)",
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            paddingTop: "20px !important",
            paddingBottom: "20px",
        },
        cardNumber: {
            [`& fieldset`]: {
                borderRadius: "4px 4px 0 0",
            },
        },
        expiration: {
            [`& fieldset`]: {
                borderRadius: " 0 0 0 4px",
            },
        },
        cryptogram: {
            [`& fieldset`]: {
                borderRadius: "0 0 4px 0",
            },
        },
        btn: {
            width: 180,
            height: 40,
            color: "#FFFFFF",
            textTransform: "initial",
            fontSize: 14,
            fontFamily: "Josefin Sans",
            marginBottom: 18,
            borderRadius: 100,
            background: "#890608",
            "&:hover": {
                background: "#EA7606",
            },
        },
        titleDialog: {
            padding: "5px 10px!important",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
        },
        actionsDialog: {
            padding: "10px !important",
        },
        annuler: {
            borderRadius: "20px !important",
            textTransform: "capitalize",
            background: "#2F45B51A!important",
            color: "#000 !important",

            fontFamily:
                'Josefin Sans,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol" !important',
            boxShadow: "none!important",
        },
        valider: {
            borderRadius: "20px !important",
            background: "#890608!important",
            color: "white !important",
            fontFamily:
                'Josefin Sans,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol" !important',
            boxShadow: "none!important",
        },
        loading: {
            width: "100%",
            position: "absolute",
            top: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            left: 0,
        },
        simpleText: {
            fontSize: 16,
            fontWeight: 300,
            lineHeight: "20px",
        },
        userInfoPaper: {
            padding: 24,
            marginBottom: theme.spacing(3),
        },
        "@global": {
            ".MuiButton-root": {
                textTransform: "none",
            },
            ".text_body": {
                lineHeight: "20px",
                fontWeight: 300,
                fontSize: 12,
            },
        },
    })
));
interface ITravellerData {
    traveller: {
        firstName: string;
        lastName: string;
        email: string;
        address: string;
        city: string;
        postalCode: string;
        country: string;
        phone: string;
        whatsappNumber: string; // Moved inside traveller object
        role: {
            name: string;
        };
    };
    digitalConfirmation: boolean;
    bookingFor: string;
    travelPurpose: string;
    carRentalInterest: boolean;
    specialRequests: string;
    arrivalTime: string;
    // Include other reservation properties as needed
}
interface IGuestData {
    guestInfo: {
        firstName: string;
        lastName: string;
        email: string;
        address: string;
        city: string;
        postalCode: string;
        country: string;
        phone: string;
        whatsappNumber: string;
        role: {  // Add this
            name: string;
        };
    };
    bookingPreferences: {
        digitalConfirmation: boolean;
        bookingFor: string;
        travelPurpose: string;
        carRentalInterest: boolean;
        specialRequests: string;
        arrivalTime: string;
    };
}

    // If you can modify IGuestData to match FormValues:
    interface FormValues {
        // Guest Info
        firstName: string;
        lastName: string;
        email: string;
        address: string;
        city: string;
        postalCode: string;
        country: string;
        phone: string;
        whatsappNumber: string; 
        whatsappCountryLogo: string;
        
        // Booking Preferences
        digitalConfirmation: boolean;
        bookingFor: string;
        travelPurpose: string;
        carRentalInterest: boolean;
        specialRequests: string;
        arrivalTime: string;
    }

const announceService = new AnnouncesService();
const confirmationReservService = new ConfirmationReservationService();
export function ConfirmReservation() {
    const [t] = useTranslation();
    const classes = useStyles();
    const params: { id: string } = useParams();
    let query = useQuery();
    const reservationContext = useContext(ReservationContext);
    const ADVANCE_PAYMENT_PERCENTAGE = 25; // % advance payment
    const [advancePayment, setAdvancePayment] = React.useState<number>(0);
    const { reservation, setReservation } = reservationContext;
    const [paymentMethod, setPaymentMethod] = React.useState(
        EPaymentMethod.Paypal
    );
    const [loadingPage, setLoadingPage] = React.useState(true);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [loadingReservation, setLoadingReservation] = React.useState(false);
    const [announce, setAnnounce] = React.useState<IAnnounce>({
        ...announceDefaultValue,
    });
    const [filteredReservation, setFilteredReservation] = React.useState([]);
    const [userServices, setUserServices] = React.useState<IUserService[]>([]);
    const [selectedItem, setSelectedItem] = React.useState<string[]>([]);
    const [paymentData, setPaymentData] =
        React.useState<IBookingPayment>(paymentDefaultValue);
    const [, setCommissionFee] = React.useState<number>(0);
    const history = useHistory();
    const sessionHandler = React.useMemo(() => new SessionHandler(), []);
    const isConnected = sessionHandler.isConnected;
    const userContext = useContext(UserContext);
    const { user, setUser } = userContext;
    const [jour, setJour] = React.useState<number>(1);
    const [amountservice, setAmoutService] = React.useState<number>(0);
    const [priceReservation, setPriceReservation] = React.useState<number>(0);
    const [updatePaymentData, setUpdatePaymentData] =
        React.useState<boolean>(false);
    const [tarif, setTarif] = React.useState(ETarifs.JOURNALIER);
    const [totalPaye, setTotalPaye] = React.useState<number>(0);
    const location = useLocation();
    const [refreshKey, setRefreshKey] = React.useState(0);
    const [paidByCredit, setPaidByCredit] = React.useState(0);
    const [isLoggedIn, setIsLoggedIn] = React.useState(false);
    const [showLogin, setShowLogin] = React.useState(false);
    const [showGuestForm, setShowGuestForm] = React.useState(true);
    const [reservationData, setReservationData] = React.useState<any>(null);
    const [formValid, setFormValid] = React.useState(false);
    const [isGuest, setIsGuest] = React.useState(false);
    const [guestFormValues, setGuestFormValues] = React.useState({
        firstName: '',
        lastName: '',
        email: '',
        address: '',
        city: '',
        postalCode: '',
        country: '',
        phone: '',
        whatsappNumber: user.phone || '', // Initialize with phone if available
        useSameNumberForWhatsapp: true, // Default checked
        whatsappCountryCode: user.country || '', // Add this
        whatsappPhoneCode: '', // Add this (will be populated when country is selected)
        digitalConfirmation: true,
        bookingFor: 'myself',
        travelPurpose: 'leisure',
        carRentalInterest: false,
        specialRequests: '',
        arrivalTime: '',
        whatsappCountryLogo: '',
    });
    const [localReservation, setLocalReservation] = React.useState({
        ...reservationContext.reservation,
        traveller: isLoggedIn ? {
            ...user,
            country: guestFormValues.country || user.country,
            phone: guestFormValues.phone || user.phone
        } : {
            ...guestFormValues
        }
    });
    const [showPaymentSection, setShowPaymentSection] = React.useState(false);
    const [travellerData, setTravellerData] = React.useState<ITravellerData | null>(null);

    
    
    const handleGuestFormChange = (newValues: any) => {
        setGuestFormValues(newValues);
        
        // Update reservation context with guest data
        setReservationData((prev: any) => ({
            ...prev,
            traveller: {
                ...prev?.traveller,
                firstName: newValues.firstName,
                lastName: newValues.lastName,
                email: newValues.email,
                country: newValues.country,
                phone: newValues.phone,
                address: newValues.address,
                city: newValues.city,
                postalCode: newValues.postalCode,
            },
            digitalConfirmation: newValues.digitalConfirmation,
            bookingFor: newValues.bookingFor,
            travelPurpose: newValues.travelPurpose,
            carRentalInterest: newValues.carRentalInterest,
            specialRequests: newValues.specialRequests,
            arrivalTime: newValues.arrivalTime,
        }));

    };

    const handleGuestSubmit = (formValues: FormValues) => {
        //console.log('Submitting:', formValues);
        const guestReservation = {
            ...reservation,
            traveller: {
                firstName: formValues.firstName,
                lastName: formValues.lastName,
                email: formValues.email,
                address: formValues.address,
                city: formValues.city,
                postalCode: formValues.postalCode,
                country: formValues.country,
                phone: formValues.phone,
                whatsappNumber: formValues.whatsappNumber,
                role: {
                    name: 'guest' // or user?.role?.name if available
                }
            },
            digitalConfirmation: formValues.digitalConfirmation,
            bookingFor: formValues.bookingFor,
            travelPurpose: formValues.travelPurpose,
            carRentalInterest: formValues.carRentalInterest,
            specialRequests: formValues.specialRequests,
            arrivalTime: formValues.arrivalTime
        };

    
        setReservation(guestReservation);
        setReservationData(guestReservation);
        setIsLoggedIn(true);
        setTravellerData(guestReservation);
        
        setTimeout(() => {
            const paymentSection = document.getElementById('payment-section');
            paymentSection?.scrollIntoView({ behavior: 'smooth' });
        }, 100);
    };

    const validateGuestForm = React.useCallback(() => {
        if (!isLoggedIn) {
            // Strict validation for guests
            return (
                formValid && // Keep existing formValid check
                guestFormValues.firstName &&
                guestFormValues.lastName &&
                guestFormValues.email &&
                guestFormValues.country &&
                guestFormValues.phone
            );
        }
        // For logged in users, only validate missing country/phone
        return !(!user.country || !user.phone);
    }, [
        formValid, 
        isLoggedIn, 
        user.country, 
        user.phone,
        guestFormValues.firstName,
        guestFormValues.lastName,
        guestFormValues.email,
        guestFormValues.country,
        guestFormValues.phone
    ]);
     
     
    const handleEditTravellerInfo = () => {
        setShowPaymentSection(false);
        // No need to reset reservation data - it's preserved
        setTimeout(() => {
            document.getElementById('traveller-form')?.scrollIntoView({ behavior: 'smooth' });
        }, 100);
    };

    
    // Utility function to calculate payment amounts
    const calculatePaymentAmounts = (totalAmount: number, creditsAvailable: number) => {
        const creditAdjustedAmount = totalAmount - creditsAvailable;
        const advancePayment = (creditAdjustedAmount * ADVANCE_PAYMENT_PERCENTAGE) / 100;
        const remainingAmount = creditAdjustedAmount - advancePayment;
        
        return {
            advancePayment: creditAdjustedAmount < 0 ? Math.abs(advancePayment) : advancePayment,
            remainingAmount,
            creditAdjustedAmount
        };
    };
    const handleLoginSuccess = (loggedInUser: any) => {
        setIsLoggedIn(true);
        setShowLogin(false);
        setUser(loggedInUser);
        setIsLoggedIn(true);
        
        // Pre-fill form with user data
        setGuestFormValues(prev => ({
            ...prev,
            firstName: loggedInUser.firstName,
            lastName: loggedInUser.lastName,
            email: loggedInUser.email,
            country: loggedInUser.country || prev.country,
            phone: loggedInUser.phone || prev.phone
        }));
    };
    
    // Unified function to set payment data with advance payment
        const setAdvancePaymentData = (
            reservation: any,
            selectedItem: any[],
            totalAmount: number,
            creditsAvailable: number,
            resAnnounce: any,
            query: URLSearchParams,
            user: any,
            _tarif: string,
            isServicePayment: boolean = false,
            serviceAmount: number = 0
        ) => {
            const { advancePayment, remainingAmount } = calculatePaymentAmounts(
                totalAmount + (isServicePayment ? serviceAmount : 0),
                creditsAvailable
            );

            return {
                method: EPaymentMethod.Paypal, // Default, can be overridden
                transaction: {
                    items: {
                        booking: {
                            ...reservation,
                            dateCheckIn: (query.get("dci") || "").replace(/-/g, "/"),
                            dateCheckOut: (query.get("dco") || "").replace(/-/g, "/"),
                            travellerAdultTotal: Number(query.get("travellerAdultTotal")),
                            travellerChildTotal: Number(query.get("travellerChildTotal")),
                            announce: resAnnounce.data,
                            traveller: {
                                ...user,
                                whatsappNumber: reservation.traveller.whatsappNumber // Include WhatsApp number
                            },
                            tarif: _tarif,
                            isAdvancePayment: true,
                            advancePaymentPercentage: ADVANCE_PAYMENT_PERCENTAGE,
                            advancePaymentAmount: advancePayment,
                            remainingAmount: remainingAmount
                        },
                        services: [...selectedItem]
                    },
                    amount: {
                        discount: 0,
                        total: advancePayment
                    }
                }
            };
        };
    

    React.useEffect(() => {
        if (user._id !== "") {
            setLoadingPage(true);
            confirmationReservService
                .getUser(user._id)
                .then((res) => {
                    if (res.success) {
                        setUser(res.data);
                        setLoadingPage(false);
                        setIsLoggedIn(true)
                    }
                })
                .catch((err) => console.log(err));
        }
    }, [refreshKey]);
    /*fin ici*/
    React.useEffect(() => {
        if (!user.email) {
            isConnected()
                .then((response: any) => {
                    if (response.success) {
                        setUser(response.data);
                        setIsLoggedIn(true)
                    }
                    setLoadingPage(false); // Always set loading to false after check
                })
                .catch((err) => {
                    //history.push("/");
                    setIsLoggedIn(false);
                    setIsGuest(true);
                    setLoadingPage(false);
                });
        } else {
            setLoadingPage(true);
            announceService
                .getAnnounceById(params.id)
                .then((resAnnounce) => {
                    if (resAnnounce.success) {
                        setAnnounce({
                            ...resAnnounce.data,
                        });
                        setFilteredReservation(
                            resAnnounce.data.reservation.filter(
                                (reservation: any) =>
                                    reservation.status[
                                        reservation.status.length - 1
                                    ].status !== EStatus.REJECTED &&
                                    reservation.status[
                                        reservation.status.length - 1
                                    ].status !== EStatus.CANCELLED &&
                                    reservation.status[
                                        reservation.status.length - 1
                                    ].status !== EStatus.CANCELLED_BY_ADMIN
                            )
                        );
                        confirmationReservService
                            .getUserServicesByUserId(resAnnounce.data.owner._id)
                            .then((response) => {
                                if (response.success) {
                                    setUserServices(response.data);
                                }
                            });

                        if (
                            query.get("travellerAdultTotal") ||
                            query.get("travellerChildTotal") ||
                            query.get("dco") ||
                            query.get("dci")
                        ) {
                            setReservation({
                                ...reservation,
                                dateCheckIn: (query.get("dci") || "").replace(
                                    /-/g,
                                    "/"
                                ),
                                dateCheckOut: (query.get("dco") || "").replace(
                                    /-/g,
                                    "/"
                                ),
                                travellerAdultTotal: Number(
                                    query.get("travellerAdultTotal")
                                ),
                                travellerChildTotal: Number(
                                    query.get("travellerChildTotal")
                                ),
                                announce: resAnnounce.data,
                                traveller: user,
                                host: resAnnounce.data.owner,
                                services: [...selectedItem],
                                creditPaye: Number(
                                    totalPayecredit(
                                        Number(
                                            user?.credits.paypal +
                                                user?.credits.mobileMoney
                                        ),
                                        Number(totalPaye)
                                    )
                                ),
                            });
                            let percentage = 0;

                            if (
                                resAnnounce.data.property?.type.name === "Hôtel"
                            ) {
                                announceService
                                    .getSpecialFeeByPropertyType(
                                        resAnnounce.data.property?.type.name
                                    )
                                    .then((responseCom) => {
                                        if (responseCom.success) {
                                            percentage = responseCom.data
                                                ? responseCom.data
                                                      .percentageTraveller
                                                : 0;
                                            setCommissionFee(percentage);
                                            let totalPrice: number;

                                            let _tarif = ETarifs.JOURNALIER;

                                            if (resAnnounce.data.promotion) {
                                                let nbjours_prom =
                                                    getDayNumberProm(
                                                        query.get("dci") || "",
                                                        query.get("dco") || "",
                                                        resAnnounce.data
                                                            .promotion
                                                            .startDate,
                                                        resAnnounce.data
                                                            .promotion.endDate,
                                                        resAnnounce.data.price,
                                                        resAnnounce.data
                                                            .promotion.price
                                                    ).DateProm;
                                                let nbjours_simple =
                                                    getDayNumberProm(
                                                        query.get("dci") || "",
                                                        query.get("dco") || "",
                                                        resAnnounce.data
                                                            .promotion
                                                            .startDate,
                                                        resAnnounce.data
                                                            .promotion.endDate,
                                                        resAnnounce.data.price,
                                                        resAnnounce.data
                                                            .promotion.price
                                                    ).DateSimple;
                                                let normalPrice;
                                                if (
                                                    nbjours_simple >= 7 &&
                                                    nbjours_simple < 14 &&
                                                    resAnnounce.data
                                                        .priceWeekly &&
                                                    resAnnounce.data
                                                        .priceWeekly > 0
                                                ) {
                                                    normalPrice =
                                                        resAnnounce.data
                                                            .priceWeekly / 7;
                                                    setTarif(
                                                        ETarifs.HEBDOMADAIRE
                                                    );
                                                    _tarif =
                                                        ETarifs.HEBDOMADAIRE;
                                                } else if (
                                                    nbjours_simple >= 14 &&
                                                    nbjours_simple < 30 &&
                                                    resAnnounce.data
                                                        .priceBiWeekly &&
                                                    resAnnounce.data
                                                        .priceBiWeekly > 0
                                                ) {
                                                    normalPrice =
                                                        resAnnounce.data
                                                            .priceBiWeekly / 14;
                                                    setTarif(ETarifs.QUINZAINE);
                                                    _tarif = ETarifs.QUINZAINE;
                                                } else if (
                                                    nbjours_simple >= 30 &&
                                                    resAnnounce.data
                                                        .priceMonthly &&
                                                    resAnnounce.data
                                                        .priceMonthly > 0
                                                ) {
                                                    normalPrice =
                                                        resAnnounce.data
                                                            .priceMonthly / 30;
                                                    setTarif(ETarifs.MENSUEL);
                                                    _tarif = ETarifs.MENSUEL;
                                                } else {
                                                    normalPrice =
                                                        resAnnounce.data.price;
                                                    setTarif(
                                                        ETarifs.JOURNALIER
                                                    );
                                                    _tarif = ETarifs.JOURNALIER;
                                                }

                                                const priceWithDays =
                                                    nbjours_simple *
                                                        normalPrice +
                                                    nbjours_prom *
                                                        resAnnounce.data
                                                            .promotion.price;
                                                const priceWithDaysWithCleaningFees =
                                                    priceWithDays +
                                                    resAnnounce.data
                                                        .cleaningFees;
                                                totalPrice = (
                                                    priceWithDaysWithCleaningFees +
                                                    priceWithDaysWithCleaningFees *
                                                        (percentage / 100)
                                                ).toFixed(2);
                                            } else {
                                                let normalPrice;
                                                if (
                                                    jour >= 7 &&
                                                    jour < 14 &&
                                                    resAnnounce.data
                                                        .priceWeekly &&
                                                    resAnnounce.data
                                                        .priceWeekly > 0
                                                ) {
                                                    normalPrice =
                                                        resAnnounce.data
                                                            .priceWeekly / 7;
                                                    setTarif(
                                                        ETarifs.HEBDOMADAIRE
                                                    );
                                                    _tarif =
                                                        ETarifs.HEBDOMADAIRE;
                                                } else if (
                                                    jour >= 14 &&
                                                    jour < 30 &&
                                                    resAnnounce.data
                                                        .priceBiWeekly &&
                                                    resAnnounce.data
                                                        .priceBiWeekly > 0
                                                ) {
                                                    normalPrice =
                                                        resAnnounce.data
                                                            .priceBiWeekly / 14;
                                                    setTarif(ETarifs.QUINZAINE);
                                                    _tarif = ETarifs.QUINZAINE;
                                                } else if (
                                                    jour >= 30 &&
                                                    resAnnounce.data
                                                        .priceMonthly &&
                                                    resAnnounce.data
                                                        .priceMonthly > 0
                                                ) {
                                                    normalPrice =
                                                        resAnnounce.data
                                                            .priceMonthly / 30;
                                                    setTarif(ETarifs.MENSUEL);
                                                    _tarif = ETarifs.MENSUEL;
                                                } else {
                                                    normalPrice =
                                                        resAnnounce.data.price;
                                                    setTarif(
                                                        ETarifs.JOURNALIER
                                                    );
                                                    _tarif = ETarifs.JOURNALIER;
                                                }
                                                const priceWithDays = Number(
                                                    getDayNumber(
                                                        (
                                                            query.get("dci") ||
                                                            ""
                                                        ).replace(/-/g, "/"),
                                                        (
                                                            query.get("dco") ||
                                                            ""
                                                        ).replace(/-/g, "/")
                                                    ) * normalPrice
                                                );
                                                const priceWithDaysWithCleaningFees =
                                                    priceWithDays +
                                                    resAnnounce.data
                                                        .cleaningFees;
                                                totalPrice = (
                                                    priceWithDaysWithCleaningFees +
                                                    priceWithDaysWithCleaningFees *
                                                        (percentage / 100)
                                                ).toFixed(2);
                                            }
                                            setPriceReservation(totalPrice);
                                            if (
                                                Number(
                                                    totalPayecredit(
                                                        Number(
                                                            user?.credits
                                                                .paypal +
                                                                user?.credits
                                                                    .mobileMoney
                                                        ),
                                                        Number(totalPaye)
                                                    )
                                                ) < 0
                                            ) {
                                                setPaidByCredit(
                                                    Number(
                                                        user?.credits.paypal +
                                                            user?.credits
                                                                .mobileMoney
                                                    )
                                                );
                                            }
                                            Number(
                                                totalPayecredit(
                                                    Number(
                                                        user?.credits.paypal +
                                                            user?.credits
                                                                .mobileMoney
                                                    ),
                                                    Number(totalPaye)
                                                )
                                            ) < 0
                                                ? setPaymentData(
                                                    (prev: any) => {
                                                        // 1. Extract and validate all amounts
                                                            const credits = Number(user?.credits.paypal || 0) + Number(user?.credits.mobileMoney || 0);
                                                            const reservationTotal = Number(totalPaye) || 0;
                                                            
                                                            // 2. Calculate credit adjustment
                                                            const creditAdjustment = totalPayecredit(credits, reservationTotal);
                                                            
                                                            // 3. Calculate amount needing payment
                                                            const amountDue = creditAdjustment >= 0 ? 0 : Math.abs(creditAdjustment);
                                                            
                                                            // 4. Calculate advance payment (50%)
                                                            const advancePayment = (amountDue * ADVANCE_PAYMENT_PERCENTAGE) / 100;
                                                            const remainingAmount = amountDue - advancePayment;
                                                            
                                                            /*console.group('[PaymentCalculation - 2]');
                                                            console.log('Credits Available:', credits);
                                                            console.log('Reservation Total:', reservationTotal);
                                                            console.log('Credit Adjustment:', creditAdjustment);
                                                            console.log('Amount Due After Credits:', amountDue);
                                                            console.log('Advance Payment (50%):', advancePayment);
                                                            console.groupEnd();*/
                                                        return {
                                                            ...prev,
                                                            method: EPaymentMethod.Paypal,
                                                            transaction: {
                                                                items: {
                                                                    booking: {
                                                                        ...reservation,
                                                                        dateCheckIn:
                                                                            (
                                                                                query.get(
                                                                                    "dci"
                                                                                ) ||
                                                                                ""
                                                                            ).replace(
                                                                                /-/g,
                                                                                "/"
                                                                            ),
                                                                        dateCheckOut:
                                                                            (
                                                                                query.get(
                                                                                    "dco"
                                                                                ) ||
                                                                                ""
                                                                            ).replace(
                                                                                /-/g,
                                                                                "/"
                                                                            ),
                                                                        travellerAdultTotal:
                                                                            Number(
                                                                                query.get(
                                                                                    "travellerAdultTotal"
                                                                                )
                                                                            ),
                                                                        travellerChildTotal:
                                                                            Number(
                                                                                query.get(
                                                                                    "travellerChildTotal"
                                                                                )
                                                                            ),
                                                                        announce:
                                                                            resAnnounce.data,
                                                                        traveller:
                                                                            user,
                                                                        tarif: _tarif,
                                                                        isAdvancePayment: true,
                                                                        advancePaymentPercentage: ADVANCE_PAYMENT_PERCENTAGE,
                                                                        advancePaymentAmount: advancePayment,
                                                                        remainingAmount: remainingAmount,
                                                                        creditAdjustedAmount: creditAdjustment
                                                                    },
                                                                },
                                                                amount: {
                                                                    discount: 0,
                                                                    total: advancePayment ,
                                                                },
                                                            },
                                                        };
                                                    }
                                                )
                                              : setPaymentData((prev: any) => {
                                                // Calculate the advance payment amount (50% of total price)
                                                const advancePayment = (totalPrice * ADVANCE_PAYMENT_PERCENTAGE) / 100;
                                                const remainingAmount = totalPrice - advancePayment;
                                                const creditAdjustment = totalPrice; // Since this is the case where credits don't cover the full amount
                                                
                                                /*console.log('[PaymentData-2] Payment details:', {
                                                    basePrice: totalPrice,
                                                    advancePayment,
                                                    remainingAmount,
                                                    creditAdjustment,
                                                    percentage: ADVANCE_PAYMENT_PERCENTAGE
                                                });*/
                                            
                                                return {
                                                    ...prev,
                                                    method: EPaymentMethod.Paypal,
                                                    transaction: {
                                                        items: {
                                                            booking: {
                                                                ...reservation,
                                                                dateCheckIn: (query.get("dci") || "").replace(/-/g, "/"),
                                                                dateCheckOut: (query.get("dco") || "").replace(/-/g, "/"),
                                                                travellerAdultTotal: Number(query.get("travellerAdultTotal")),
                                                                travellerChildTotal: Number(query.get("travellerChildTotal")),
                                                                announce: resAnnounce.data,
                                                                traveller: user,
                                                                tarif: _tarif,
                                                                // Add advance payment fields
                                                                isAdvancePayment: true,
                                                                advancePaymentPercentage: ADVANCE_PAYMENT_PERCENTAGE,
                                                                advancePaymentAmount: advancePayment,
                                                                remainingAmount: remainingAmount,
                                                                creditAdjustedAmount: creditAdjustment
                                                            },
                                                        },
                                                        amount: {
                                                            discount: 0,
                                                            total: advancePayment,
                                                        },
                                                    },
                                                };
                                            });
                                        }
                                    })
                                    .catch((error) => console.log(error));
                            } else {
                                announceService
                                    .getCommissionFeeByCountryAndCityId(
                                            resAnnounce.data.property?.address
                                                ?.country.name,
                                        resAnnounce.data?.property?.address
                                            ?.city.name
                                    )
                                    .then((responseCom) => {
                                        if (responseCom.success) {
                                            percentage = responseCom.data
                                                ? responseCom.data.percentage
                                                : 0;
                                            setCommissionFee(percentage);
                                            let totalPrice: number;

                                            let _tarif = ETarifs.JOURNALIER;

                                            if (resAnnounce.data.promotion) {
                                                let nbjours_prom =
                                                    getDayNumberProm(
                                                        query.get("dci") || "",
                                                        query.get("dco") || "",
                                                        resAnnounce.data
                                                            .promotion
                                                            .startDate,
                                                        resAnnounce.data
                                                            .promotion.endDate,
                                                        resAnnounce.data.price,
                                                        resAnnounce.data
                                                            .promotion.price
                                                    ).DateProm;
                                                let nbjours_simple =
                                                    getDayNumberProm(
                                                        query.get("dci") || "",
                                                        query.get("dco") || "",
                                                        resAnnounce.data
                                                            .promotion
                                                            .startDate,
                                                        resAnnounce.data
                                                            .promotion.endDate,
                                                        resAnnounce.data.price,
                                                        resAnnounce.data
                                                            .promotion.price
                                                    ).DateSimple;
                                                let normalPrice;
                                                if (
                                                    nbjours_simple >= 7 &&
                                                    nbjours_simple < 14 &&
                                                    resAnnounce.data
                                                        .priceWeekly &&
                                                    resAnnounce.data
                                                        .priceWeekly > 0
                                                ) {
                                                    normalPrice =
                                                        resAnnounce.data
                                                            .priceWeekly / 7;
                                                    setTarif(
                                                        ETarifs.HEBDOMADAIRE
                                                    );
                                                    _tarif =
                                                        ETarifs.HEBDOMADAIRE;
                                                } else if (
                                                    nbjours_simple >= 14 &&
                                                    nbjours_simple < 30 &&
                                                    resAnnounce.data
                                                        .priceBiWeekly &&
                                                    resAnnounce.data
                                                        .priceBiWeekly > 0
                                                ) {
                                                    normalPrice =
                                                        resAnnounce.data
                                                            .priceBiWeekly / 14;
                                                    setTarif(ETarifs.QUINZAINE);
                                                    _tarif = ETarifs.QUINZAINE;
                                                } else if (
                                                    nbjours_simple >= 30 &&
                                                    resAnnounce.data
                                                        .priceMonthly &&
                                                    resAnnounce.data
                                                        .priceMonthly > 0
                                                ) {
                                                    normalPrice =
                                                        resAnnounce.data
                                                            .priceMonthly / 30;
                                                    setTarif(ETarifs.MENSUEL);
                                                    _tarif = ETarifs.MENSUEL;
                                                } else {
                                                    normalPrice =
                                                        resAnnounce.data.price;
                                                    setTarif(
                                                        ETarifs.JOURNALIER
                                                    );
                                                    _tarif = ETarifs.JOURNALIER;
                                                }

                                                const priceWithDays =
                                                    nbjours_simple *
                                                        normalPrice +
                                                    nbjours_prom *
                                                        resAnnounce.data
                                                            .promotion.price;
                                                const priceWithDaysWithCleaningFees =
                                                    priceWithDays +
                                                    resAnnounce.data
                                                        .cleaningFees;
                                                totalPrice = (
                                                    priceWithDaysWithCleaningFees +
                                                    priceWithDaysWithCleaningFees *
                                                        (percentage / 100)
                                                ).toFixed(2);
                                            } else {
                                                let normalPrice;
                                                if (
                                                    jour >= 7 &&
                                                    jour < 14 &&
                                                    resAnnounce.data
                                                        .priceWeekly &&
                                                    resAnnounce.data
                                                        .priceWeekly > 0
                                                ) {
                                                    normalPrice =
                                                        resAnnounce.data
                                                            .priceWeekly / 7;
                                                    setTarif(
                                                        ETarifs.HEBDOMADAIRE
                                                    );
                                                    _tarif =
                                                        ETarifs.HEBDOMADAIRE;
                                                } else if (
                                                    jour >= 14 &&
                                                    jour < 30 &&
                                                    resAnnounce.data
                                                        .priceBiWeekly &&
                                                    resAnnounce.data
                                                        .priceBiWeekly > 0
                                                ) {
                                                    normalPrice =
                                                        resAnnounce.data
                                                            .priceBiWeekly / 14;
                                                    setTarif(ETarifs.QUINZAINE);
                                                    _tarif = ETarifs.QUINZAINE;
                                                } else if (
                                                    jour >= 30 &&
                                                    resAnnounce.data
                                                        .priceMonthly &&
                                                    resAnnounce.data
                                                        .priceMonthly > 0
                                                ) {
                                                    normalPrice =
                                                        resAnnounce.data
                                                            .priceMonthly / 30;
                                                    setTarif(ETarifs.MENSUEL);
                                                    _tarif = ETarifs.MENSUEL;
                                                } else {
                                                    normalPrice =
                                                        resAnnounce.data.price;
                                                    setTarif(
                                                        ETarifs.JOURNALIER
                                                    );
                                                    _tarif = ETarifs.JOURNALIER;
                                                }
                                                const priceWithDays = Number(
                                                    getDayNumber(
                                                        (
                                                            query.get("dci") ||
                                                            ""
                                                        ).replace(/-/g, "/"),
                                                        (
                                                            query.get("dco") ||
                                                            ""
                                                        ).replace(/-/g, "/")
                                                    ) * normalPrice
                                                );
                                                const priceWithDaysWithCleaningFees =
                                                    priceWithDays +
                                                    resAnnounce.data
                                                        .cleaningFees;
                                                totalPrice = (
                                                    priceWithDaysWithCleaningFees +
                                                    priceWithDaysWithCleaningFees *
                                                        (percentage / 100)
                                                ).toFixed(2);
                                            }
                                            setPriceReservation(totalPrice);
                                            if (
                                                Number(
                                                    totalPayecredit(
                                                        Number(
                                                            user?.credits
                                                                .paypal +
                                                                user?.credits
                                                                    .mobileMoney
                                                        ),
                                                        Number(totalPaye)
                                                    )
                                                ) < 0
                                            ) {
                                                setPaidByCredit(
                                                    Number(
                                                        user?.credits.paypal +
                                                            user?.credits
                                                                .mobileMoney
                                                    )
                                                );
                                            }
                                            Number(
                                                totalPayecredit(
                                                    Number(
                                                        user?.credits.paypal +
                                                            user?.credits
                                                                .mobileMoney
                                                    ),
                                                    Number(totalPaye)
                                                )
                                            ) < 0
                                                ? setPaymentData(
                                                    (prev: any) => {
                                                        // 1. Extract and validate all amounts
                                                        const credits = Number(user?.credits.paypal || 0) + Number(user?.credits.mobileMoney || 0);
                                                        const reservationTotal = Number(totalPaye) || 0;
                                                        
                                                        // 2. Calculate credit adjustment
                                                        const creditAdjustment = totalPayecredit(credits, reservationTotal);
                                                        
                                                        // 3. Calculate amount needing payment
                                                        const amountDue = creditAdjustment >= 0 ? 0 : Math.abs(creditAdjustment);
                                                        
                                                        // 4. Calculate advance payment (50%)
                                                        const advancePayment = (amountDue * ADVANCE_PAYMENT_PERCENTAGE) / 100;

                                                        const remainingAmount = amountDue - advancePayment;
                                                        
                                                        /*console.group('[PaymentCalculation - 3]');
                                                        console.log('Credits Available:', credits);
                                                        console.log('Reservation Total:', reservationTotal);
                                                        console.log('Credit Adjustment:', creditAdjustment);
                                                        console.log('Amount Due After Credits:', amountDue);
                                                        console.log('Advance Payment (50%):', advancePayment);
                                                        console.groupEnd(); */
                                                        return {
                                                            ...prev,
                                                            method: EPaymentMethod.Paypal,
                                                            transaction: {
                                                                items: {
                                                                    booking: {
                                                                        ...reservation,
                                                                        dateCheckIn:
                                                                            (
                                                                                query.get(
                                                                                    "dci"
                                                                                ) ||
                                                                                ""
                                                                            ).replace(
                                                                                /-/g,
                                                                                "/"
                                                                            ),
                                                                        dateCheckOut:
                                                                            (
                                                                                query.get(
                                                                                    "dco"
                                                                                ) ||
                                                                                ""
                                                                            ).replace(
                                                                                /-/g,
                                                                                "/"
                                                                            ),
                                                                        travellerAdultTotal:
                                                                            Number(
                                                                                query.get(
                                                                                    "travellerAdultTotal"
                                                                                )
                                                                            ),
                                                                        travellerChildTotal:
                                                                            Number(
                                                                                query.get(
                                                                                    "travellerChildTotal"
                                                                                )
                                                                            ),
                                                                        announce:
                                                                            resAnnounce.data,
                                                                        traveller:
                                                                            user,
                                                                        tarif: _tarif,
                                                                        isAdvancePayment: true,
                                                                        advancePaymentPercentage: ADVANCE_PAYMENT_PERCENTAGE,
                                                                        advancePaymentAmount: advancePayment,
                                                                        remainingAmount: remainingAmount,
                                                                        creditAdjustedAmount: creditAdjustment
                                                                    },
                                                                },
                                                                amount: {
                                                                    discount: 0,
                                                                    total: advancePayment ,
                                                                },
                                                            },
                                                        };
                                                    }
                                                )
                                                : setPaymentData((prev: any) => {
                                                    // Calculate the advance payment amount (50% of total price)
                                                    const advancePayment = (totalPrice * ADVANCE_PAYMENT_PERCENTAGE) / 100;
                                                    const remainingAmount = totalPrice - advancePayment;
                                                    const creditAdjustment = totalPrice; // Since this is the case where credits don't cover the full amount
                                                    
                                                    /*console.log('[PaymentData-2] Payment details:', {
                                                        basePrice: totalPrice,
                                                        advancePayment,
                                                        remainingAmount,
                                                        creditAdjustment,
                                                        percentage: ADVANCE_PAYMENT_PERCENTAGE
                                                    }); */
                                                
                                                    return {
                                                        ...prev,
                                                        method: EPaymentMethod.Paypal,
                                                        transaction: {
                                                            items: {
                                                                booking: {
                                                                    ...reservation,
                                                                    dateCheckIn: (query.get("dci") || "").replace(/-/g, "/"),
                                                                    dateCheckOut: (query.get("dco") || "").replace(/-/g, "/"),
                                                                    travellerAdultTotal: Number(query.get("travellerAdultTotal")),
                                                                    travellerChildTotal: Number(query.get("travellerChildTotal")),
                                                                    announce: resAnnounce.data,
                                                                    traveller: user,
                                                                    tarif: _tarif,
                                                                    // Add advance payment fields
                                                                    isAdvancePayment: true,
                                                                    advancePaymentPercentage: ADVANCE_PAYMENT_PERCENTAGE,
                                                                    advancePaymentAmount: advancePayment,
                                                                    remainingAmount: remainingAmount,
                                                                    creditAdjustedAmount: creditAdjustment
                                                                },
                                                            },
                                                            amount: {
                                                                discount: 0,
                                                                total: advancePayment,
                                                            },
                                                        },
                                                    };
                                                });
                                        }
                                    })
                                    .catch((error) => console.log(error));
                            }
                        }
                    }

                    setLoadingPage(false);
                })
                .catch((errAnnounce) => {
                    setLoadingPage(false);
                });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        setReservation,
        setAnnounce,
        user,
        history,
        isConnected,
        setUser,
        priceReservation,
        jour,
        Number(
            totalPayecredit(
                Number(user?.credits.paypal + user?.credits.mobileMoney),
                Number(totalPaye)
            )
        ),
        totalPaye,
        paidByCredit
    ]);

    


    React.useEffect(() => {
        setReservation({
            ...reservation,
            tarif,
        });
    }, [tarif]);

    let tab_photos: any = [];
    let tab_reservation: any = [];
    let res_occupe: any = [];
    announce.property.photos.forEach((photo: any) => {
        tab_photos.push(photo);
    });
    if (announce.reservation[0] !== undefined) {
        announce.reservation &&
            filteredReservation.forEach((date: any, indx: number) => {
                var date1 = new Date(
                    moment(date.dateCheckIn).format("MM/DD/YYYY")
                );
                var date2 = new Date(
                    moment(date.dateCheckOut).format("MM/DD/YYYY")
                );

                // moment(announceAd.startAt).add(announceAd.adParam.duration, 'days').format("DD-MM-YYYY")
                var time_diff = date2.getTime() - date1.getTime();
                var days_Diff = time_diff / (1000 * 3600 * 24);
                for (let i = 0; i < days_Diff; i++) {
                    //   res_occupe.push(new Date(new Date(date.dateCheckIn).setDate(new Date(date.dateCheckIn).getDate() + i)));
                    res_occupe.push(
                        new Date(
                            moment(
                                new Date(date.dateCheckIn).setDate(
                                    new Date(date.dateCheckIn).getDate() + i
                                )
                            ).format("YYYY/MM/DD")
                        )
                    );
                }
                tab_reservation.push({
                    id: indx,
                    title: t("label.reserve-detail"),
                    allDay: true,
                    start: new Date(date.dateCheckIn),
                    end: new Date(date.dateCheckOut),
                    //   jour:[new Date(date.dateCheckIn),new Date(date.dateCheckOut)],
                });
            });
    }

    let jours: number;
    if ((query.get("dco") || "") && (query.get("dci") || "")) {
        var msMinute = 60 * 1000,
            msDay = 60 * 60 * 24 * 1000,
            a: any = new Date(query.get("dci") || ""),
            b: any = new Date(query.get("dco") || "");
        jours = Math.floor((b - a) / msDay);
    } else {
        jours = 1;
    }
    React.useEffect(() => {
        setJour(jours);
    }, [jours]);
    let dateCheck: any = [];
    for (let i = 0; i < jour; i++) {
        dateCheck.push(
            moment(
                new Date(
                    moment(
                        new Date(query.get("dci") || "").setDate(
                            new Date(query.get("dci") || "").getDate() + i
                        )
                    ).format("YYYY/MM/DD")
                )
            ).format("YYYY/MM/DD")
        );
    }
    let icluRes: any = [];
    //if(location.pathname !== '/search'){
    if (res_occupe[0] !== undefined) {
        res_occupe.forEach((inc: any) => {
            let test = dateCheck.includes(moment(inc).format("YYYY/MM/DD"));
            icluRes.push(test);
        });
    }
    if (announce.dateIndisponible !== undefined) {
        announce &&
            announce.dateIndisponible.forEach((date: any) => {
                let test = dateCheck.includes(
                    moment(date).format("YYYY/MM/DD")
                );
                icluRes.push(test);
            }, []);
    }

    React.useEffect(() => {
        let totalService: number = 0;

        
    
        if (selectedItem.length > 0) {
            selectedItem.forEach((val) => {
                userServices.forEach((userService: IUserService) => {
                    if (userService._id === val) {
                        totalService += userService.price;
                    }
                });
            });
        }
    
        setReservation({
            ...reservation,
            services: [...selectedItem],
        });
    
        //console.log("starting the ConvertedDeviseWithoutMoneySign... useEffect ")
        ConvertedDeviseWithoutMoneySign(
            "XAF",
            paymentData?.transaction.items?.booking.announce.devise,
            totalService
        ).then((price: any) => {
            setAmoutService(price);
            Number(
                totalPayecredit(
                    Number(user?.credits.paypal + user?.credits.mobileMoney),
                    Number(totalPaye)
                )
            ) < 0
                ? setPaymentData((prev) => {
                    // 1. Extract and validate all amounts
                        const credits = Number(user?.credits.paypal || 0) + Number(user?.credits.mobileMoney || 0);
                        const reservationTotal = Number(totalPaye) || 0;
                        
                        // 2. Calculate credit adjustment
                        const creditAdjustment = totalPayecredit(credits, reservationTotal);
                        
                        // 3. Calculate amount needing payment
                        const amountDue = creditAdjustment >= 0 ? 0 : Math.abs(creditAdjustment);
                        
                        // 4. Calculate advance payment (50%)
                        const advancePayment = (amountDue * ADVANCE_PAYMENT_PERCENTAGE) / 100;

                        const remainingAmount = amountDue - advancePayment;
                        
                        /*console.group('[PaymentCalculation - 5]');
                        console.log('Credits Available:', credits);
                        console.log('Reservation Total:', reservationTotal);
                        console.log('Credit Adjustment:', creditAdjustment);
                        console.log('Amount Due After Credits:', amountDue);
                        console.log('Advance Payment (50%):', advancePayment);
                        console.groupEnd(); */
                    return {
                        ...prev,
                        transaction: {
                            items: {
                                booking: {
                                    ...reservation,
                                    isAdvancePayment: true,
                                    advancePaymentPercentage: ADVANCE_PAYMENT_PERCENTAGE,
                                    advancePaymentAmount: advancePayment,
                                    remainingAmount: remainingAmount,
                                    creditAdjustedAmount: creditAdjustment
                                },
                                services: [...selectedItem],
                            },
                            amount: {
                                discount: 0,
                                total: advancePayment ,
                            },
                        },
                    };
                })
                :setPaymentData((prev) => {
                    // Calculate total amount (base price + services)
                    const totalAmount = Number(priceReservation) + Number(price);
                    // Calculate advance payment (50% of total)
                    const advancePayment = (totalAmount * ADVANCE_PAYMENT_PERCENTAGE) / 100;
                    const remainingAmount = totalAmount - advancePayment;
                    
                    // Calculate credit adjustment (total amount minus any credits used)
                    const creditsAvailable = Number(user?.credits.paypal || 0) + Number(user?.credits.mobileMoney || 0);
                    const creditAdjustment = totalAmount - creditsAvailable;
                
                    /*console.log('[PaymentData-6] Payment details:', {
                        basePrice: priceReservation,
                        servicePrice: price,
                        totalAmount,
                        advancePayment,
                        remainingAmount,
                        creditAdjustment,
                        percentage: ADVANCE_PAYMENT_PERCENTAGE
                    }); */
                
                    return {
                        ...prev,
                        transaction: {
                            items: {
                                booking: {
                                    ...reservation,
                                    // Add advance payment fields
                                    isAdvancePayment: true,
                                    advancePaymentPercentage: ADVANCE_PAYMENT_PERCENTAGE,
                                    advancePaymentAmount: advancePayment,
                                    remainingAmount: remainingAmount,
                                    creditAdjustedAmount: creditAdjustment
                                },
                                services: [...selectedItem],
                            },
                            amount: {
                                discount: 0,
                                total: advancePayment,
                            },
                        },
                    };
                });
        });
    }, [selectedItem, userServices, priceReservation]);  
    

    React.useEffect(() => {
        if (updatePaymentData) {
            let totalService: number = 0;
            if (selectedItem.length > 0) {
                selectedItem.forEach((val) => {
                    userServices.forEach((userService: IUserService) => {
                        if (userService._id === val) {
                            totalService += userService.price;
                        }
                    });
                });
            }

            setReservation({
                ...reservation,
                services: [...selectedItem],
            });

            Number(
                totalPayecredit(
                    Number(user?.credits.paypal + user?.credits.mobileMoney),
                    Number(totalPaye)
                )
            ) < 0
                ? setPaymentData((prev) => {
                    // 1. Extract and validate all amounts
                    const credits = Number(user?.credits.paypal || 0) + Number(user?.credits.mobileMoney || 0);
                    const reservationTotal = Number(totalPaye) || 0;
                    
                    // 2. Calculate credit adjustment
                    const creditAdjustment = totalPayecredit(credits, reservationTotal);
                    
                    // 3. Calculate amount needing payment
                    const amountDue = creditAdjustment >= 0 ? 0 : Math.abs(creditAdjustment);
                    
                    // 4. Calculate advance payment (50%)
                    const advancePayment = (amountDue * ADVANCE_PAYMENT_PERCENTAGE) / 100;
                    const remainingAmount = amountDue - advancePayment;
                    
                    /*console.group('[PaymentCalculation - 7]');
                    console.log('Credits Available:', credits);
                    console.log('Reservation Total:', reservationTotal);
                    console.log('Credit Adjustment:', creditAdjustment);
                    console.log('Amount Due After Credits:', amountDue);
                    console.log('Advance Payment (50%):', advancePayment);
                    console.log('Remaining Amount:', remainingAmount);
                    console.groupEnd(); */
                
                    return {
                        ...prev,
                        transaction: {
                            items: {
                                booking: {
                                    ...reservation,
                                    // Add advance payment tracking fields
                                    isAdvancePayment: true,
                                    advancePaymentPercentage: ADVANCE_PAYMENT_PERCENTAGE,
                                    advancePaymentAmount: advancePayment,
                                    remainingAmount: remainingAmount,
                                    creditAdjustedAmount: creditAdjustment,
                                    // Preserve existing credit fields
                                    creditPaye: creditAdjustment >= 0 ? credits : reservationTotal + credits,
                                    paidByCredit: creditAdjustment >= 0 ? reservationTotal : credits
                                },
                                services: [...selectedItem],
                            },
                            amount: {
                                discount: 0,
                                total: advancePayment,
                            },
                        },
                    };
                })
                : setPaymentData((prev) => {
                    // 1. Calculate base components
                    const basePrice = Number(priceReservation) || 0;
                    const servicesPrice = Number(amountservice) || 0;
                    const totalAmount = basePrice + servicesPrice;
                    
                    // 2. Calculate credit adjustments
                    const creditsAvailable = Number(user?.credits.paypal || 0) + Number(user?.credits.mobileMoney || 0);
                    const creditAdjustment = totalAmount - creditsAvailable;
                    const amountDue = creditAdjustment >= 0 ? creditAdjustment : 0;
                    
                    // 3. Calculate payment breakdown
                    const advancePayment = (totalAmount * ADVANCE_PAYMENT_PERCENTAGE) / 100;
                    const remainingAmount = totalAmount - advancePayment;
                
                    /*console.group('[PaymentData-8] Detailed Payment Breakdown');
                    console.log('Base Price:', basePrice);
                    console.log('Services Price:', servicesPrice);
                    console.log('Total Amount:', totalAmount);
                    console.log('Credits Available:', creditsAvailable);
                    console.log('Credit Adjustment:', creditAdjustment);
                    console.log('Amount Due:', amountDue);
                    console.log('Advance Payment:', advancePayment);
                    console.log('Remaining Amount:', remainingAmount);
                    console.groupEnd(); */
                
                    return {
                        ...prev,
                        transaction: {
                            items: {
                                booking: {
                                    ...reservation,
                                    // Payment tracking fields
                                    isAdvancePayment: true,
                                    advancePaymentPercentage: ADVANCE_PAYMENT_PERCENTAGE,
                                    advancePaymentAmount: advancePayment,
                                    remainingAmount: remainingAmount,
                                    creditAdjustedAmount: creditAdjustment,
                                    // Credit information
                                    creditPaye: Math.min(creditsAvailable, totalAmount),
                                    paidByCredit: Math.min(creditsAvailable, totalAmount)
                                },
                                services: [...selectedItem],
                            },
                            amount: {
                                discount: 0,
                                total: advancePayment,
                            },
                        },
                    };
                });

            setUpdatePaymentData(false);
        }
    }, [updatePaymentData]);

    const onChangePaymentMethod = (event: any) => {
        setPaymentMethod(event.target.value);
        if (event.target.value === EPaymentMethod.Paypal) {
            setPaymentData((prev) => {
                /*console.log('[PaymentData-9] Payment method changed to PayPal', {
                    currentAmount: prev.transaction.amount.total,
                    advancePaymentDetails: prev.transaction.items.booking
                }); */
                return {
                    ...prev,
                    method: event.target.value,
                    // Preserve all existing payment data including advance payment fields
                    transaction: {
                        ...prev.transaction,
                        items: {
                            ...prev.transaction.items,
                            booking: {
                                ...prev.transaction.items.booking,
                                // No changes to advance payment fields needed
                            }
                        }
                    }
                };
            });
        } else {
            setPaymentData((prev) => {
                const accountIdentifier = user.payments?.mobileMoney?.filter(
                    (mobile) => mobile.mobile_operator === event.target.value
                )[0];
                /*console.log('[PaymentData-10] Payment method changed to Mobile Money', {
                    currentAmount: prev.transaction.amount.total,
                    advancePaymentDetails: prev.transaction.items.booking
                }); */
                return {
                    ...prev,
                    method: event.target.value,
                    accountIdentifier: accountIdentifier?.mobile_number,
                    providerIdentifier: getProviderIdentifier(event.target.value),
                    // Preserve all existing payment data including advance payment fields
                    transaction: {
                        ...prev.transaction,
                        items: {
                            ...prev.transaction.items,
                            booking: {
                                ...prev.transaction.items.booking,
                                // No changes to advance payment fields needed
                            }
                        }
                    }
                };
            });
        }
    };

    const handleRemoveItem = (val: string) => {
        setSelectedItem(selectedItem.filter((item) => item !== val));
        setPaymentData((prev: any) => {
            /*console.log('[PaymentData-11] Service item removed', {
                removedService: val,
                currentAmount: prev.transaction.amount.total,
                advancePaymentDetails: prev.transaction.items.booking
            }); */
            return {
                ...prev,
                transaction: {
                    ...prev.transaction,
                    items: {
                        ...prev.transaction.items,
                        booking: {
                            ...prev.transaction.items.booking,
                            // Recalculate advance payment fields if needed
                            // (or keep existing values if they shouldn't change)
                        },
                        services: selectedItem.filter((item) => item !== val)
                    },
                    // You may want to recalculate the amount here if service prices affect the total
                    amount: {
                        discount: 0,
                        total: prev.transaction.amount.total // Or recalculate if needed
                    }
                }
            };
        });
    };

    const getSelectedItemComponent = (id: string) => {
        let userServiceVal: IUserService = userServices.filter(
            (userService) => userService._id === id
        )[0];
        return (
            <SelectedServiceItem
                key={userServiceVal._id}
                userService={userServiceVal}
                handleRemoveItem={handleRemoveItem}
            />
        );
    };

    React.useEffect(() => {
        if (query.has("failed")) {
            query.delete("failed");
            history.replace({
                search: query.toString(),
            });
            FlashMessage({
                type: "error",
                message: t("paiement.message.vous-avez-annule"),
            });
        }
    }, [query, history]);
    const onPayeCredit = (paymentData: IBookingPayment) => {
        setLoadingReservation(true);

        // Use the reservationData which contains guest info if needed
        const reservationToSave = {
            ...reservation,
            traveller: isLoggedIn ? {
                ...user,
                // Override with form values if they exist
                country: guestFormValues.country || user.country,
                phone: guestFormValues.phone || user.phone,
                whatsappNumber: guestFormValues.whatsappNumber 
            } : {
                // Use guest form data
                ...guestFormValues
            },
            services: [...selectedItem],
            creditPaye: Number(
                totalPayecredit(
                    Number(user?.credits.paypal + user?.credits.mobileMoney),
                    Number(totalPaye)
                ))
        };

        confirmationReservService.saveReservation(reservation).then((res) => {
            if (res.success) {
                setRefreshKey((oldKey) => oldKey + 1);
                //history.push(
                //    `/booking/payment-done-successfully-${res.data._id}`
                //);
                confirmationReservService
                    .saveTransaction({
                        method: EPaymentMethod.Credit,
                        billingToken: "",
                        facilitatorAccessToken: "",
                        orderID: "",
                        payerID: "",
                        paymentID: null,
                        link: "",
                        paymentEmail: "",
                        reservation: res.data,
                        announceAd: null,
                        amount: paymentData.transaction.amount.total,
                        type: ETransactionType.Sending,
                    })
                    .then((resp) => {
                        if (resp.success) {
                            history.push(
                                `/booking/payment-done-successfully-${resp.data._id}`
                            );
                            confirmationReservService
                                .sendReservationNotification(
                                    resp.data.reservation
                                )
                                .catch((error) => {
                                    console.log(error);
                                    setLoadingPage(false);
                                });
                        }
                        setLoadingPage(false);
                    })
                    .catch((err) => {
                        setLoadingPage(false);
                    });
            }
        });
    };
    const changePoping = () => {
        setOpenDialog(true);
    };
    const handleClose = () => {
        setOpenDialog(false);
    };

    /*
    React.useEffect(() => {
        console.log("Debugging Payment Data, Amount Service, and Price Reservation:");
        console.log("Payment Data:", paymentData);
        console.log("Amount Service:", amountservice);
        console.log("Price Reservation:", priceReservation);
    }, [paymentData, amountservice, priceReservation]); 

   
        console.log("Payment Data:", paymentData);
        console.log("Transaction:", paymentData?.transaction);
        console.log("Items:", paymentData?.transaction?.items);
        console.log("Booking:", paymentData?.transaction?.items?.booking);
        console.log("Announce:", paymentData?.transaction?.items?.booking?.announce); 
        console.log("Devise:", paymentData?.transaction?.items?.booking?.announce?.devise); */

        const creditsTotal = Number(user?.credits.paypal + user?.credits.mobileMoney);
    const totalPayeNum = Number(totalPaye);
    const result = Number(totalPayecredit(creditsTotal, totalPayeNum));
    
    //console.log('Debug - creditsTotal:', creditsTotal, 'totalPaye:', totalPayeNum, 'result:', result);

    // Add an early return for loading state
    if (loadingPage) {
        return (
            <div className={classes.loading}>
                <PropagateLoader color="#36D7B7" size={15} />
            </div>
        );
    }

    const paymentLogos =
  announce.property?.address?.country.name === "Cameroon"
    ? [MTNMobileMoney_logo, OrangeMoney_logo, PayPal_logo, Visa2_logo, MasterCard_logo]
    : [PayPal_logo, Visa2_logo, MasterCard_logo];
 
    return (
        <div>
            <Grid container direction="column" alignItems="center">
                {loadingPage /* && reservation.dateCheckIn==='' */ ? (
                    <div className={classes.loading}>
                        <PropagateLoader color="#36D7B7" size={15} />
                    </div>
                ) : (
                    <>
                        <Grid item>
                            <div style = {{justifyContent: 'center', color: '#890806', marginBottom: 20}}>
                                <h1 style={{ fontSize: '24px'}}>
                                    {t("label.recapitulatif-de-votre-reservation")}
                                </h1>
                            </div>
                        </Grid>
                        <Grid
                            container
                            spacing={3}
                            direction="row"
                            justifyContent="space-between"
                            style={{ minHeight: 1064 }}
                        >
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <ConfirmReservationCard
                                    announce={announce}
                                    userServices={userServices}
                                    selectedServices={selectedItem}
                                    setUpdatePaymentData={setUpdatePaymentData}
                                    cond={
                                        icluRes.includes(true) &&
                                        announce?.property?.type.name !==
                                            "Hôtel"
                                    }
                                    setTotalPaye={setTotalPaye}
                                    paidByCredit={paidByCredit}
                                    advancePaymentPercentage={ADVANCE_PAYMENT_PERCENTAGE}
                                />
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                {/*}
                                {userServices.length > 0 && (
                                    <Grid
                                        container
                                        direction="column"
                                        spacing={2}
                                    >
                                        <Grid item>
                                            <Typography>
                                                <p>{t("reservation.offres")}</p>
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <MultiSelectWithCheckBox
                                                values={userServices}
                                                setSelectedItem={
                                                    setSelectedItem
                                                }
                                                selectedItem={selectedItem}
                                            />
                                        </Grid>
                                        <Grid item>
                                            {selectedItem.length > 0 &&
                                                selectedItem.map((item) =>
                                                    getSelectedItemComponent(
                                                        item
                                                    )
                                                )}
                                        </Grid>
                                    </Grid>
                                )} */}
                                <Grid item style={{ marginBottom: 30 }}>
                                    <GuestCheckoutForm 
                                        announce={announce}
                                        onSuccess={handleGuestSubmit}
                                        isLoggedIn={isLoggedIn}
                                        user={{
                                            firstName: user?.firstName || '',
                                            lastName: user?.lastName || '',
                                            email: user?.email || '',
                                            country: user?.country || '',
                                            phone: user?.phone || '',
                                            role: {
                                                name: user?.role?.name || ''
                                            }
                                        }}
                                        values={guestFormValues}
                                        onChange={handleGuestFormChange}
                                        showSubmitButton={!showPaymentSection}
                                        onValidationChange={setFormValid}
                                    />
                                    {/* Error messages */}
                                    {!isLoggedIn && !formValid && (
                                    <Typography color="error" variant="body2" style={{ marginBottom: 10 }}>
                                        {t("error.pleaseCompleteAllRequiredFields")}
                                    </Typography>
                                    )}
                                    {isLoggedIn && (!user.country || !user.phone) && !formValid && (
                                    <Typography color="error" variant="body2" style={{ marginBottom: 10 }}>
                                        {t("error.pleaseProvideCountryAndPhone")}
                                    </Typography>
                                    )}
                                </Grid>

                                
                                <Paper elevation={2} className={classes.userInfoPaper}>
                                <Grid container direction="column" spacing={3}>
                                    <Grid item>
                                        <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                                        {t("label.payer-avec")}
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Grid container spacing={2} justifyContent="center" alignItems="center">
                                            {paymentLogos.map((logo, index) => (
                                            <Grid item key={index}>
                                                <img
                                                src={logo}
                                                alt={`payment-method-${index}`}
                                                style={{
                                                    width: "50px",
                                                    height: "50px",
                                                    objectFit: "contain",
                                                    borderRadius: "4px",
                                                }}
                                                />
                                            </Grid>
                                            ))}
                                        </Grid>
                                    </Grid>

                                    {/* Credit Payment Button */}
                                    <Grid item>
                                    {totalPayecredit(
                                        Number(user?.credits.paypal + user?.credits.mobileMoney),
                                        Number(totalPaye)
                                        ) >= 0 && (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            style={{ marginBottom: 20, padding: '10px 0' }}
                                            disabled={loadingReservation || (!isLoggedIn && !validateGuestForm())}
                                            onClick={changePoping}
                                        >
                                            {t("label.payer-avec-le-credit")}
                                        </Button>
                                        )}
                                    </Grid>

                                    {/* Payment Methods Section */}
                                    <Grid item>
                                        {location.pathname.startsWith("/booking/details-announce") ? (
                                        !icluRes.includes(true) || announce?.property?.type.name === "Hôtel" ? (
                                            <>
                                            <Select
                                                id="paymentMethodSelection"
                                                name="paymentMethod"
                                                variant="outlined"
                                                fullWidth
                                                value={paymentMethod}
                                                onChange={onChangePaymentMethod}
                                                style={{ marginBottom: 20 }}
                                            >
                                                {paymentMethodList.map((method) => (
                                                <MenuItem key={method.label + method.value} value={method.value}>
                                                    {method.label}
                                                </MenuItem>
                                                ))}
                                            </Select>

                                            <Grid container direction="column" spacing={2}>
                                                {paymentMethod === EPaymentMethod.Paypal && (
                                                <Grid item>
                                                    <PaypalBookingPaymentButtons
                                                    paymentData={paymentData}
                                                    setLoadingPage={setLoadingPage}
                                                    paidByCredit={paidByCredit}
                                                    />
                                                </Grid>
                                                )}
                                                {paymentMethod !== EPaymentMethod.Paypal && (
                                                <Grid item>
                                                    <DohonePayementButton
                                                    paymentData={paymentData}
                                                    paidByCredit={paidByCredit}
                                                    />
                                                </Grid>
                                                )}
                                            </Grid>
                                            </>
                                        ) : null
                                        ) : (
                                        <>
                                            <Select
                                            id="paymentMethodSelection"
                                            name="paymentMethod"
                                            variant="outlined"
                                            fullWidth
                                            value={paymentMethod}
                                            onChange={onChangePaymentMethod}
                                            style={{ marginBottom: 20 }}
                                            >
                                            {paymentMethodList.map((method) => (
                                                <MenuItem key={method.label + method.value} value={method.value}>
                                                {method.label}
                                                </MenuItem>
                                            ))}
                                            </Select>

                                            <Grid container direction="column" spacing={2}>
                                            {paymentMethod === EPaymentMethod.Paypal && (
                                                <Grid item>
                                                <PaypalBookingPaymentButtons
                                                    paymentData={paymentData}
                                                    setLoadingPage={setLoadingPage}
                                                    paidByCredit={paidByCredit}
                                                />
                                                </Grid>
                                            )}
                                            {paymentMethod !== EPaymentMethod.Paypal && (
                                                <Grid item>
                                                <DohonePayementButton
                                                    paymentData={paymentData}
                                                    paidByCredit={paidByCredit}
                                                />
                                                </Grid>
                                            )}
                                            </Grid>
                                        </>
                                        )}
                                    </Grid>
                                </Grid>
                                </Paper>   
                            </Grid>                            
                        </Grid>
                    </>
                )}
            </Grid>
            <Dialog open={openDialog} maxWidth="sm">
                <DialogTitle style={{ padding: 0 }}>
                    <div className={classes.titleDialog}>
                        <span className={classes.title}>
                            {t("label.confirmation-paiement")}
                        </span>
                        <IconButton aria-label="close" onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                </DialogTitle>
                <DialogContent className={classes.contentDialog}>
                    {t("label.confirmer-votre-paiement")}
                </DialogContent>
                <DialogActions className={classes.actionsDialog}>
                    <Button
                        variant="contained"
                        className={classes.annuler}
                        style={{ textTransform: "none" }}
                        onClick={handleClose}
                    >
                        {t("reservation.button.cancel")}
                    </Button>
                    <Button
                        variant="contained"
                        className={classes.valider}
                        style={{ textTransform: "none" }}
                        endIcon={loadingReservation ? <Spin /> : null}
                        onClick={() => onPayeCredit(paymentData)}
                        disabled={loadingReservation || (!isLoggedIn && !validateGuestForm())}
                    >
                        {t("reservation.button.valider")}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

